import { CircleConfig, CircleData, CircleTextStyle } from '../../../models/internal_api/circleInterfaces.model';
import DataCircle from '../DataCircle/DataCircle';
import './TodaysEventsCircle.scss';

export default function TodaysEventsCircle(circleData: CircleData) {
    const headerStyle: CircleTextStyle = {
        fontSize: circleData.headerSize ? circleData.headerSize : '32px'
    };

    const textStyle: CircleTextStyle = {
        fontSize: circleData.textSize ? circleData.textSize : '14px'
    };

    const circleConfig: CircleConfig = {
        circleData: circleData,
        filled: true,
        headerStyle: headerStyle,
        textStyle: textStyle
    }

    return (
        <div className='TodaysEventsCircle'>
            <DataCircle {...circleConfig} />
        </div>
    );
}